var React = require('react');

function Court (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"prefix__Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"prefix__Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M66.46 52h-32C31.44 52 29 55 29 58.64v1.79c0 3.67 2.49 6.65 5.54 6.65h32c3.06 0 5.54-3 5.54-6.65v-1.79C72 55 69.52 52 66.46 52zM69 60.43c0 2-1.16 3.65-2.54 3.65h-32c-1.38 0-2.54-1.67-2.54-3.65v-1.79c0-2 1.16-3.65 2.54-3.65h32C67.84 55 69 56.66 69 58.64zM31.32 46.39a1.5 1.5 0 001.5 1.5h35.31a1.5 1.5 0 000-3H32.82a1.5 1.5 0 00-1.5 1.5zM40.69 30.79h-.87a1.5 1.5 0 000 3h21.31a1.5 1.5 0 000-3h-.87V3h.87a1.5 1.5 0 000-3H39.82a1.5 1.5 0 000 3h.87v12.39H1.5a1.5 1.5 0 000 3h39.19zm3 0V3h13.57v27.79z","fill":"inherit"}))));
}

Court.defaultProps = {"viewBox":"0 0 72 67.08","fill":"inherit","stroke":"none"};

module.exports = Court;

Court.default = Court;
